<template>
    <div class="firm-info">
        <veui-loading
            :loading="isLoading"
            class="main-loading"
            ui="strong l"
        >
            加载中
        </veui-loading>
        <template v-if="!isLoading">
            <div v-if="(subType === 'company' || subType === 'other') && status === 'pass'">
                <div class="content">
                    <!-- 简介修改态 -->
                    <intro-management
                        v-show="isModify"
                        :profile="profile"
                        :business-id="businessId"
                        @cancle="cancle"
                        @submit="submitSucc"
                    />
                    <!-- 简介只读态 -->
                    <intro-show
                        v-show="!isModify"
                        :firm-info="profile"
                        :business-id="businessId"
                        @clickModify="clickModify"
                    />
                </div>
            </div>
            <div v-else class="authenticate-guide">
                <div class="authenticate-guide-content">
                    <img class="no-data-img" src="https://lvlin-base.cdn.bcebos.com/bend/no-data.png"/>
                    <div v-if="subType === '' && status === ''">您当前未进行企业百家号资质认证，请先进行企业百家号资质认证后再行登录</div>
                    <div v-else-if="(subType === 'company' || subType === 'other') && status === 'audit'">
                        当前您的企业百家号仍处于审核中状态，请审核通过后再登录
                    </div>
                    <div v-else>当前您的企业百家号资质认证失败，请认证成功后再行登录</div>
                    <a href="https://baijiahao.baidu.com/builder/theme/bjh/steptwo" target="_blank">点击去企业百家号进行认证</a>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
/**
 * @file index.vue
 * @author zhengyixin
 * @desc 律所简介
 */
import IntroManagement from '../components/intro-management';
import IntroShow from '../components/intro-show';
import confirm from 'veui/plugins/confirm';
import {Loading} from 'veui';
import {mapState} from 'vuex';
import Vue from 'vue';
Vue.use(confirm);

export default {
    name: 'firmintro',
    components: {
        IntroManagement,
        IntroShow,
        'veui-loading': Loading
    },
    data() {
        return {
            subType: '',
            status: '',
            profile: {},
            // 加载中
            isLoading: true,
            businessId: 0,
            isModify: false // 是否是修改中状态
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew,
            // 律所
            lawBusinessInfo: state => state.lawStore.userInfoNew?.law_business_info || {}
        })
    },
    watch: {
        lawBusinessInfo: {
            deep: true,
            immediate: true,
            handler() {
                if (!this.lawBusinessInfo.id) {
                    return;
                }
                this.businessId = this.lawBusinessInfo.id;
                this.getProfile();
            }
        }
    },
    methods: {
        getProfile() {
            let businessId = this.businessId;
            // 页面曝光打点
            this.$log && this.$log.send({
                type: 'show',
                value: 'firm-intro-show',
                ext: {
                    businessId
                },
                page: 'firmintro'
            });
            this.$http.get('/bp/api/business/getprofile', {
                params: {
                    businessId
                }
            }).then(res => {
                this.isLoading = false;
                if (!res || +res.code !== 0 || !res.data) {
                    return;
                }
                const profile = res.data?.profile || {};
                this.profile = profile;
                this.subType = profile.subType || '';
                this.status = profile.status || '';
                // 页面成功展示曝光打点
                this.$log && this.$log.send({
                    type: 'show',
                    value: 'firm-intro-show-success',
                    ext: {
                        businessId,
                        subType: this.subType
                    }
                });
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.isLoading = false;
            });
        },
        // 点击修改
        clickModify() {
            this.isModify = true;
        },
        // 取消修改
        cancle() {
            this.isModify = false;
        },
        // 修改成功
        submitSucc() {
            this.isModify = false;
            this.getProfile();
        }
    }
};
</script>
<style lang="stylus" scoped>
    .firm-info {
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;
        line-height: 1;
        padding-bottom: 48px;
        background: #fff;
        min-height: 700px;
        position: relative;

        .main-loading {
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .authenticate-guide {
        position: relative;
        width: 100%;
        height: 100%;
        background: #fff;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;

        .authenticate-guide-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333;
            text-align: center;

            .no-data-img {
                width: 200px;
                height: 180px;
                margin-bottom: 3px;
            }

            a {
                display: block;
                margin-top: 13px;
            }
        }

        .step-box {
            height: 132px;
            display: flex;
            background: #fff;
            align-items: center;
            justify-content: center;
            border-radius: 8px;
        }
    }

    .num {
        height: 46px;
        width: 46px;
        border-radius: 50%;
        border: 2px solid rgba(238, 238, 238, 1);
        font-family: PingFangTC-Medium;
        font-size: 20px;
        color: #999;
        font-weight: 500;
        text-align: center;
        line-height: 44px;
        margin: 0 auto;

        &:hover {
            cursor: pointer;
        }
    }

    /deep/.title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        padding: 30px 0 30px 30px;
        color: #000;
        font-weight: 500;
        display: flex;
        align-items: center;

        .tip {
            margin-left: 6px;
            height: 16px;
        }
    }
</style>